import React from 'react';
import { string, shape, bool, func } from 'prop-types';
import { TableCell, Tooltip, TableSortLabel } from '@mui/material';

const Cell = ({ order, label, name, onSort }) => {
  const sortBy = () => onSort(name);

  return (
    <TableCell sx={{ border: 0, pt: 0, pb: 0, fontSize: '13px' }}>
      <Tooltip title="Sort" enterDelay={300}>
        <TableSortLabel
          active={order.by === name}
          onClick={sortBy}
          direction={order.isReverse ? 'desc' : 'asc'}
        >
          {label}
        </TableSortLabel>
      </Tooltip>
    </TableCell>
  );
};

Cell.propTypes = {
  label: string.isRequired,
  name: string.isRequired,
  onSort: func.isRequired,
  order: shape({
    by: string.isRequired,
    isReverse: bool.isRequired,
  }).isRequired,
};

export default Cell;
